module.exports = __webpack_public_path__ + "static/media/save2.0c50600e.svg";